import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"
import {Hidden as MUIHidden, AccordionSummary, Accordion, AccordionDetails} from "@mui/material"

export const StyledAccordion = styled(Accordion)`
    background: none;
    box-shadow: none;
    width: 100%;
    border: none;
`
export const StyledAccordionDetails = styled(AccordionDetails)`
    padding: 0.5rem 0;
`

export const StyledAccordionSummary = styled(AccordionSummary)`
    && {
        @media (min-width: ${breakpoints.values.md}px) {
            background: ${({theme}) => theme.uxfabric.components.menu.megaMenu.default.backgroundColor};
        }
        padding: 0;
        min-height: auto;
        max-height: unset;
        width: 100%;
        && > div {
            margin: 0;
        }
        > div:nth-of-type(2) {
            display: flex;
            justify-content: space-around;
            height: 2.75rem;
            width: 2.75rem;
        }
    }
`
export const Hidden = styled(MUIHidden)`
    width: 100%;
`

export const Container = styled("div")`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: start;
    @media (min-width: ${breakpoints.values.lg}px) {
        border-top: 0;
    }
`

export const Button = styled("button")`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    outline: inherit;
    align-items: center;
    display: flex;
    justify-content: center;
`
